module.exports = __webpack_public_path__ + "static/media/sim.c7408ea4.png";